import { createSlice } from '@reduxjs/toolkit';

export const initialCustomerListQuery = {
    PageNumber: 1,
    PageSize: 50,
    UserID: null,
    ProductID: null,
    CustomerNumber: null,
    MobileNumber: null,
    PhoneNumber: null,
    CaseDetails: '',
    BusinessName: '',
    StatusMasterID: null,
    AssignTo: null,
    Email: null,
    FromDate: null,
    ToDate: null,
};

const positiveInteger = (value, fallback) => {
    const number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : fallback;
};

const serializeDate = value => {
    if (value == null || value === '') return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export function normalizeCustomerListQuery(query = {}) {
    const normalized = { ...initialCustomerListQuery, ...query };
    return {
        ...normalized,
        PageNumber: positiveInteger(normalized.PageNumber, 1),
        PageSize: positiveInteger(normalized.PageSize, 50),
        FromDate: serializeDate(normalized.FromDate),
        ToDate: serializeDate(normalized.ToDate),
    };
}

// Normalize before dispatch so calendar Date/dayjs values never enter Redux actions.
const prepareQuery = query => ({ payload: normalizeCustomerListQuery(query) });
const replaceQuery = (_, action) => action.payload;

const CustomerListSlice = createSlice({
    name: 'customerList',
    initialState: initialCustomerListQuery,
    reducers: {
        setCustomerListQuery: { reducer: replaceQuery, prepare: prepareQuery },
        resetCustomerListQuery: { reducer: replaceQuery, prepare: prepareQuery },
    },
});

export const { setCustomerListQuery, resetCustomerListQuery } = CustomerListSlice.actions;
export default CustomerListSlice.reducer;
